var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSatisfactionSurvey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 31.167c7.824 0 14.167-6.343 14.167-14.167S24.824 2.833 17 2.833 2.833 9.176 2.833 17 9.176 31.167 17 31.167zM9.72 19.18a7.584 7.584 0 0014.56 0",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.006 14.82a1.635 1.635 0 100-3.269 1.635 1.635 0 000 3.27zM22.885 14.82a1.635 1.635 0 100-3.269 1.635 1.635 0 000 3.27z",
    fill: "currentColor"
  })));
}
export default SvgSatisfactionSurvey;